import React from 'react'

import styled from 'styled-components'

import { Button } from '../Button'

const FormWrapper = ({
  form,
  first,
  last,
  onNextStep,
  onPrevStep,
  onSubmit,
}) => {
  return (
    <StyledFormWrapper>
      {form}
      <ButtonWrapper>
        {(first || !last) && (
          <Button
            handleClick={onNextStep}
            width="110px"
            height="3rem"
            radius="8px"
            btnClass="info"
          >
            Next
          </Button>
        )}
        {last && (
          <Button
            handleClick={onSubmit}
            width="110px"
            height="3rem"
            radius="8px"
            btnClass="success"
          >
            Submit
          </Button>
        )}
        {!first && (
          <Button
            handleClick={onPrevStep}
            width="110px"
            height="3rem"
            radius="8px"
            btnClass="primary"
          >
            Go Back
          </Button>
        )}
      </ButtonWrapper>
    </StyledFormWrapper>
  )
}

const StyledFormWrapper = styled.div`
  max-width: 500px;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: 1rem;
  gap: 1rem;
`

export default FormWrapper
